import { combineReducers } from '@reduxjs/toolkit';

import { allocatedSlice } from './allocatedSlice';
import { unAllocatedSlice } from './unAllocatedSlice';

export const apartments = combineReducers({
  allocated: allocatedSlice.reducer,
  unAllocated: unAllocatedSlice.reducer,
});
